// extracted by mini-css-extract-plugin
export var card = "_6p-0";
export var expandedCard = "_6p-2";
export var paginated = "_6p-1";